module.exports = __webpack_public_path__ + "img/undraw-for-sale.a887ccf2.svg";